import React from "react";
import ChipSelect from "../../../components/chipSelect";
import FieldLabel from "../../../components/label";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { options } from "../../../defaultValues/product";
import { withStyles } from "@mui/styles";
import { useStyles } from "../indexFormStyles";
import { Box, Stack, TextField, Typography } from "@mui/material";

function CustomerDetailsFilledForm({
  classes: { accordianGreen, accordianSection, contentScroller, formGroup },
  accordian,
  form,
  errorMessage,
  handleAccordianClick,
  handleChange,
  handleChangeChipSelect,
  validateInputLength,
}) {
  return (
    <>
      <Box
        className={`${accordianSection} ${accordianGreen}`}
        onClick={() => handleAccordianClick("filled", accordian.filled)}
      >
        <Stack
          direction="row"
          gap={1}
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
        >
          <CheckCircleOutlineIcon sx={{ color: "green" }} />
          <Typography variant="subtitle2">Aadhaar Verified Details</Typography>
        </Stack>
        <Box>
          {!accordian.filled && <ExpandMoreIcon fontSize="medium" />}
          {accordian.filled && <ExpandLessIcon fontSize="medium" />}
        </Box>
      </Box>

      {accordian.filled && (
        <Box p={1} mt={0} sx={{ height: "52vh" }} className={contentScroller}>
          <Box className={formGroup} pt={0}>
            <FieldLabel label={"Gender*"} />
            <ChipSelect
              compact={false}
              fontWeight={"regular"}
              fieldname={"gender"}
              handleChange={handleChangeChipSelect}
              options={options.gender}
              selectedItem={form.gender}
              disabled={true}
            />
            {/* // <TextField
              //   id="standard-basic"
              //   variant="outlined"
              //   value={form.gender}
              //   name="gender"
              //   onInput={validateInputLength}
              //   onChange={handleChange}
              //   autoComplete="off"
              //   helperText={errorMessage.gender}
              //   disabled={true}
              //   className="disabled"
              //   fullWidth
              // /> */}
          </Box>

          <Box className={formGroup} pt={0}>
            <FieldLabel label={"Full Name*"} />
            <TextField
              id="standard-basic"
              variant="outlined"
              value={form.name}
              name="name"
              onInput={validateInputLength}
              onChange={handleChange}
              autoComplete="off"
              helperText={errorMessage.name}
              disabled={true}
              className="disabled"
              fullWidth
            />
          </Box>

          <Box className={formGroup} pt={0}>
            <FieldLabel label={"Date of Birth*"} />
            <TextField
              type="date"
              id="standard-basic"
              variant="outlined"
              value={form.dob}
              name="dob"
              onInput={validateInputLength}
              onChange={handleChange}
              autoComplete="off"
              helperText={errorMessage.dob}
              style={{ width: "100%" }}
              disabled={true}
              className="disabled"
              fullWidth
            />
          </Box>

          <Box className={formGroup} pt={0}>
            <FieldLabel label={"Address*"} />
            <TextField
              id="standard-basic"
              variant="outlined"
              value={form.address}
              name="address"
              onInput={validateInputLength}
              onChange={handleChange}
              autoComplete="off"
              helperText={errorMessage.address}
              disabled={true}
              className="disabled"
              fullWidth
              multiline
              rows={3}
            />
          </Box>
        </Box>
      )}
    </>
  );
}

export default withStyles(useStyles, { withTheme: true })(
  CustomerDetailsFilledForm
);
